import * as z from 'zod'

export default function getOperatorFormSchema(isEditing = false) {
	return z.object({
		username: z
			.string({
				required_error: 'จำเป็นต้องกรอกชื่อผู้ใช้',
			})
			.min(1, {
				message: 'จำเป็นต้องกรอกชื่อผู้ใช้',
			}),
		password: isEditing
			? z
					.string()
					.min(8, {
						message: 'ต้องกรอกรหัสผ่านอย่างน้อย 8 อักษร',
					})
					.optional()
			: z
					.string({
						required_error: 'จำเป็นต้องกรอกรหัสผ่าน',
					})
					.min(8, {
						message: 'ต้องกรอกรหัสผ่านอย่างน้อย 8 อักษร',
					}),
		userGroupId: z
			.string({
				required_error: 'จำเป็นต้องกรอก User Group ID',
			})
			.min(1, {
				message: 'จำเป็นต้องกรอก User Group ID',
			}),
		phone: z
			.string({
				required_error: 'จำเป็นต้องกรอกเบอร์โทรศัทพ์',
			})
			.min(1, {
				message: 'จำเป็นต้องกรอกเบอร์โทรศัทพ์',
			}),
		isActive: z.boolean().default(true),
	})
}
